/**
 * Tenant configuration (OVO-132 — dedicated single-tenant instances).
 *
 * A "dedicated instance" is the SAME build, deployed per client with a different
 * env block. When `REACT_APP_SINGLE_TENANT=true`, the app runs as one implicit
 * tenant: all multi-partner machinery (the Partners page, partner pickers,
 * partner columns, the "shared route" tag, the by-partner stats) is hidden, and
 * the chrome is re-branded from these env vars. Default (flag off) = full OVO
 * multi-partner behaviour, byte-for-byte unchanged.
 *
 * Read once at module load (CRA bakes REACT_APP_* at build time). Toggling the
 * flag back to false restores OVO mode — nothing here is destructive.
 */

const env = process.env;

export const tenantConfig = {
  /** Hide every multi-partner surface and run as one implicit tenant. */
  isSingleTenant: env.REACT_APP_SINGLE_TENANT === 'true',

  /** Branding (consumed by the header, document title, banners). */
  appName: env.REACT_APP_APP_NAME || 'OVO Planner',
  shortName: env.REACT_APP_SHORT_NAME || 'OVO',
  orgName: env.REACT_APP_ORG_NAME || env.REACT_APP_APP_NAME || 'OVO',
  logoPath: env.REACT_APP_LOGO_PATH || '/logo.svg',
  /** Login-page background image (the left panel). Defaults to the OVO image. */
  loginBackground: env.REACT_APP_LOGIN_BG || '/SignIn/bg.png',
  primaryColor: env.REACT_APP_PRIMARY_COLOR || null,

  /**
   * Optional fixed top banner label (e.g. an instance name). Distinct from the
   * green DEV banner / the demo badge. Null = no banner.
   */
  instanceBanner: env.REACT_APP_INSTANCE_BANNER || null,
};

/** Convenience flag — most call sites only need this. */
export const isSingleTenant = tenantConfig.isSingleTenant;

export default tenantConfig;
